import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useController } from 'react-hook-form';
import { Asterisk, Inner, Label, Message, Outer, PhoneInputRow } from './input.styles';
import { buildCountryData, defaultCountries, parseCountry, PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
export default function Mobile({ children, defaultCountry, name, label, control, rules, shouldUnregister, type, isRequired, updateMobile, ...inputProps }) {
    const { field, fieldState: { error }, } = useController({
        name,
        control,
        rules,
        shouldUnregister,
    });
    const countries = React.useMemo(() => defaultCountries.map((country) => {
        const parsedCountry = parseCountry(country);
        if (parsedCountry.iso2 !== 'au') {
            return country;
        }
        return buildCountryData({
            ...parsedCountry,
            format: {
                default: '.... ... ...',
                '/^0/': '.... ... ...',
                '/^4/': '... ... ...',
            },
        });
    }), []);
    return (_jsxs(Outer, { isError: !!error, children: [_jsxs(Inner, { type: type, children: [label && (_jsxs(Label, { htmlFor: label, children: [children ?? label, isRequired && _jsx(Asterisk, { children: "*" })] })), _jsx(PhoneInputRow, { children: _jsx(PhoneInput, { countries: countries, defaultCountry: defaultCountry?.toLowerCase() ?? 'nz', forceDialCode: true, value: field.value ?? undefined, name: name, "data-testid": name, onChange: (phone, meta) => {
                                updateMobile(phone, meta.country.iso2.toUpperCase());
                            } }) })] }), !!error && _jsx(Message, { children: error.message })] }));
}
